import { useCallback, useMemo } from 'react';
// eslint-disable-next-line max-len
import { useDeleteVariantConfiguratorColorSettingAssetMutation } from '../../../../api/mutations/deleteVariantConfiguratorColorSettingAsset';
// eslint-disable-next-line max-len
import { useUploadVariantConfiguratorColorSettingAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorColorSettingAsset';
import { VariantConfiguratorAsset } from '../../../../api/types';

const useHandleColorSettingAsset = () => {
    const [uploadColorSettingAssetMutation] = useUploadVariantConfiguratorColorSettingAssetMutation();
    const [deleteColorSettingAssetMutation] = useDeleteVariantConfiguratorColorSettingAssetMutation();

    const uploadColorSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, colorSettingId: string, upload: File) => {
            const { data } = await uploadColorSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    colorSettingId,
                    type: VariantConfiguratorAsset.ColorSettingImage,
                    upload,
                },
            });

            return data?.variantConfigurator.colorBlock;
        },
        [uploadColorSettingAssetMutation]
    );

    const deleteColorSettingAsset = useCallback(
        async (variantConfiguratorId: string, blockId: string, colorSettingId: string) => {
            const { data } = await deleteColorSettingAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    blockId,
                    colorSettingId,
                    type: VariantConfiguratorAsset.ColorSettingImage,
                },
            });

            return data?.variantConfigurator.colorBlock;
        },
        [deleteColorSettingAssetMutation]
    );

    return useMemo(
        () => ({
            uploadColorSettingAsset,
            deleteColorSettingAsset,
        }),
        [deleteColorSettingAsset, uploadColorSettingAsset]
    );
};

export default useHandleColorSettingAsset;
